import React, { useState } from "react";
import { Button, Modal, Text } from "@mantine/core";
import { TransactionExportService } from "../../../services/transactionExport.service";
import { DateRange } from "../../../models/DateRange";
import { Loader } from "@mantine/core";
import styles from "./ExportCSVButton.module.scss";
import { useDisclosure } from "@mantine/hooks";
import { TabType } from "../../addressDetailsTabs/AddressDetailsTabs.component";

export default function ExportCSVButton({
  address,
  tnxCategory = TabType.confirmed,
  disabled = false,
  onClose = null as (() => void) | null,
  dateRange = null,
}: {
  address: string;
  tnxCategory: TabType | null;
  disabled?: boolean;
  onClose?: (() => void) | null;
  dateRange: DateRange | null;
}) {
  const [loading, setLoading] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);

  const handleClick = async () => {
    if (loading) {
      return;
    }
    try {
      setLoading(true);

      let csvString = "";

      if (tnxCategory === TabType.cChain ) {
        csvString = await TransactionExportService.fetchCChainTransactions(
          address,
          dateRange,
          1000
        );
      }
      else if (tnxCategory === TabType.confirmed) {
        csvString = await TransactionExportService.fetchPChainTransactions(
          address,
          dateRange,
        );
      } else {
        csvString = "";
        console.error("Unsupported tab type");
      }

      const blob = new Blob([csvString], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "transactions.csv";

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      a.remove();
      if (onClose) onClose();
      setLoading(false);
    } catch (error) {
      console.error("Error exporting transactions:", error);
      open();
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        disabled={disabled}
        className={styles.exportButton}
        onClick={handleClick}
      >
        Download
        {loading && <Loader type="dots" m="sm" color="white" size={20} />}
      </Button>

      <Modal.Root opened={opened} onClose={close}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title c={"var(--quinary)"}>
              <Text className={styles.errrorTitle}>
                Transaction export error
              </Text>
            </Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <Text className={styles.errorText}>
              There was a problem exporting your transactions. Please try again
              later
            </Text>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
